package domain.player

import engine.model.HandlingConfig
import kotlinx.serialization.Serializable

/**
 * Unified player profile holding identity and all persisted preferences.
 * This is the single source of truth for everything player-specific.
 */
@Serializable
data class PlayerProfile(
    val username: String = "guest",
    @Serializable(with = HandlingConfigSerializer::class)
    val handling: HandlingConfig = HandlingConfig(),
    val graphics: GraphicsConfig = GraphicsConfig(),
    val keyBindings: Map<GameAction, List<String>> = emptyMap(),
)
